import React from 'react';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import strings from "../Globalization/index";
import NonMedivatorTable from '../AppGrid/NonMedivatorTable';
import { useBreadcrumbs } from '../contexts/Breadcrumbs';
import { useUniqueEffect } from '../hooks';
import catAdminUtil from '../util/catAdminUtils';
import consts from '../consts';
import connectionService from '../services/Connection';

const NonMedivator = () => {
	const [breadcrumbs, setBreadcrumbs] = useBreadcrumbs();
	const navigate = useNavigate();

	useUniqueEffect(() => {
		const docTitle = strings.ScopesAdd;
		const breadcrumbsText = strings.ScopesAdd;
		const infoMessageValue = strings.ScopesMessage;
		setBreadcrumbs({
			docTitle,
			breadcrumbs: [{ text: breadcrumbsText }],
			infoMessage: { isvisible: true, value: infoMessageValue },
		});
	}, [breadcrumbs]);
	return (
		<Grid container>
			<Grid size={12}>
				<NonMedivatorTable onSubmit={(values, { activeRecord, ...parms }) => catAdminUtil.handleOnSubmit({
					values,
					activeRecord,
					maxCount: consts.maxScopesCount,
					message: strings.ScopesCountWarning,
					apiUrl: connectionService.Nonmedivator,
					navigate,
					navigateUrl: "/quicksearchscope",
					...parms
				})} />
			</Grid>
		</Grid>
	);
}

export default NonMedivator;